
export default[
    {
        show(row,extra){
            return row.isend==='0'
        },
        tag:'my-btn',
        type:'edit',
        text:'修改评价',
        click(row,extra){
            this.$emit('getEdit')
            
        }
    },{
        show(row,extra){
            return row.isend==='-1'
        },
        tag:'my-btn',
        type:'edit',
        text:'服务评价',
        click(row,extra){
            this.$emit('getTk')
        }
    },{
        show(row,extra){
            return row.isend==='1'
        },
        tag:'my-btn',
        type:'detail',
        text:'查看评价',
        click(row,extra){
            this.$emit('getDetail')
        }
    },
]